/*
 * @Descripttion: 短信节点
 * @Author: yang chenglin
 */

import { lazy } from 'ice';
import UUID from '@/utils/UUID';
import utils from '@/common/utils';
import iconImage from '@/assets/images/CanvasImages/sms.svg';
import Form from './Form';
import Info from './Info';

export default {
  info: {
    icon: 'icon-iconlujingyunsuan-06',
    // iconText: '&#xe673;',
    iconText: iconImage,
    name: 'MARKETING_SMS',
    label: '官方人群短信', // 上线后需换成发短信
    // 输入类型： 0-无 1-人群包 2-人群包列表
    inputType: 1, // 输入人群包
    minInputCount: 1, // 最小输入数量1
    maxInputCount: 1, // 最大输入数量1
    // 输出类型： 0-可选 1-人群包 2-人群包列表
    outputType: 1, // 输出人群包列表
    minOutputCount: 0, // 最小输出数量0
    maxOutputCount: 0, // 最大输出数量0
    desc: '对该节点连接的前一个节点里的可触达人群投放短信任务'
  },
  data: () => ({
    name: `官方人群短信 ${UUID.getNowTime()}`,
    smsContent: '', // 短信内容
    smsNum: 1, // 短信条数
    // poOrderId: '', // 宝洁特有PO号
    executionTime: 0, // 执行时间
    executionMinute: '0', // 循环执行类型，执行时间有分钟限制
    smsSign: '', // 签名
    smsCount: '', // 短信余额
    shortLink: '', // 短链接
    smsModelId: null, // 短信模板id
    filterBlackList:false,// 判别是否勾选屏蔽黑名单
    addWhiteList:false,//判别是否勾选添加白名单
    filterAlreadySend: null, // 屏蔽近多少天短信营销人群
    filterOrderCount:null,//屏蔽历史订单超过多少的营销人群
    filterMaxMemberCount:null,//发送上限(真实传给后端的人数)
    filterMaxMemberCountShow:null,//发送上限(input框里输入的内容，其实算条数，但是由于各种原因【已在短信营销里阐述】，就选择这样传参了)
    filterLastOrderTime: null,//屏蔽最近多少天内下单的人
    filterCrowdName: '', // 屏蔽人群包名
    filterCrowdId: '', // 屏蔽人群包id
    url: '', // 长链接
    cycleType: null, // 执行方式 1-单次执行 2-循环执行
    smsTimeDifference: 1, // 0-立即执行 1-定时执行
    preResourceType: '', // 前置节点类型，目前只有批量短信需要传
  }),

  validators: {
    name: (val, allNodeData = [], currentNode = {}, getAllNodes = []) =>
      new Promise((resolve, reject) => {
        // allNodeData是点击menu上各种操作的按钮操作之后的节点数据，getAllNodes是从画布上直接得到的所有现有节点的id，
        // 当通过按钮删除节点的时候走前者，allNodeData是删除后的数据，但当不通过删除组件按钮删除节点，而是通过键盘Del键时，
        // 是直接走的画布上的键盘监听方法，改变不了allNodeData，因此此处判断节点名称是否重复的时候，要计算一下
        // 例如：画布上现有节点id[1,2,3]，键盘Del键删掉3之后，allNodeData仍然是[1,2,3]，而getAllNodes是[1,2]
        allNodeData.forEach((item, index) => {
          if (!getAllNodes.includes(item.nodeId)) {
            allNodeData.splice(index, 1);
          }
        });
        try {
          if (val === '') {
            reject(new Error('节点名称不能为空'));
          } else if (
            allNodeData.filter((item) => {
              if (item.data.name === val && item.nodeId !== currentNode.nodeId)
                return item;
            }).length >= 1
          ) {
            reject(new Error('节点名称不能与其他节点重复'));
          } else {
            resolve();
          }
        } catch (error) {
          throw error;
        }
      }),
    // poOrderId: (val) =>
    //   new Promise((resolve, reject) => {
    //     try {
    //       if ((val === '' || val === 0) && utils.isPGShop()) {
    //         reject(new Error('PO号不能为空'));
    //       } else {
    //         resolve();
    //       }
    //     } catch (error) {
    //       throw error;
    //     }
    //   }),
    executionTime: (val) =>
      new Promise((resolve, reject) => {
          try {
            if (val.toString().length <= 8 && (val === '' || val === null || Number.isNaN(val)) && val !== 0) {
              reject(new Error('发送时间不能为空'));
            } else if (val !== 0 && val.toString().length > 8 && val < new Date().getTime() + 10*60*1000) {
              reject(new Error('短信发送时间应大于当前时间10分钟'));
            } else if (
              val.toString().length <= 8 &&
              String(val).split(':')[0] < 9  && val !== 0
            ) {
              reject(new Error('请正确填写发送时间'));
            } else {
              resolve();
            }
        } catch (error) {
          throw error;
        }
      }),
    smsSign: (val) =>
      new Promise((resolve, reject) => {
        try {
          if (val === '') {
            reject(new Error('短信签名不能为空'));
          } else {
            resolve();
          }
        } catch (error) {
          throw error;
        }
      }),
    smsCount: (val) =>
      new Promise((resolve, reject) => {
        try {
          if (val === '' || val === 0) {
            reject(new Error('短信余额不能为0'));
          } else {
            resolve();
          }
        } catch (error) {
          throw error;
        }
      }),
    smsContent: (val) =>
      new Promise((resolve, reject) => {
        try {
          if (val === '') {
            reject(new Error('短信内容不能为空'));
          } else {
            resolve();
          }
        } catch (error) {
          throw error;
        }
      }),
  },
  components: {
    // Form: lazy(() => import('./Form')),
    // Info: lazy(() => import('./Info')),
    Form: Form,
    Info: Info,
  },
};
